import { TableRow, TableCell } from "@/components/ui/table";

export default function TableRowSkeleton({
    columnsLength,
}: {
    columnsLength: number;
}) {
    return (
        <TableRow className="animate-pulse even:bg-gray-100 hover:even:bg-gray-100">
            {Array.from({ length: columnsLength }).map((_, i) => (
                <TableCell key={i}>
                    <div className="h-5 w-full rounded bg-gray-200" />
                </TableCell>
            ))}
        </TableRow>
    );
}
